// extracted by mini-css-extract-plugin
export default {"levelBadge":"wuAsB7JlDvJTu3Du4wLA"};